import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {getSeriusLevel} from "../../api/apiClient";


const ComboFaultGrade = ({
                           propLabel = '장애상태',
                           propOnChange = null,
                           propDefaultValue,
                           propLocation = '',
                         }) => {

/*  useEffect(() => {
    console.log(propDefaultValue);
  }, [propDefaultValue]);*/

  /* 장애등급 목록 data */
  const [seriusLevel, setSeriusLevel] = useState([]);

  /* 장애등급 목록 갱신 */
  const updateList = () => {
    getSeriusLevel()
        .then((res) => {
              // console.log(res.data.data.list);
              setSeriusLevel(res.data.data.list);
            }
        );
  };

  useEffect(() => {
    updateList();
  }, []);

  return (
      <Form.Group as={Row} controlId="formBasicSelectMenu">
        <Form.Label
            className={`col-form-label label text-end ${propLocation === "SEARCH" ? "" : "fw-bold"}`}
            style={{width: "100px"}}
        >
          {propLabel}
        </Form.Label>
        <Col>
          <Form.Select
              aria-label="faultGrade Select"
              className={"input input-select"}
              onChange={propOnChange}
              value={propDefaultValue}
              // key={propDefaultValue}
          >
            {propLocation === "search" ? <option value={""}>전체</option> : ''}
            {Array.isArray(seriusLevel) ?
                (seriusLevel.map((elem, idx) => {
                  return (
                      <option key={idx} value={elem.cd}>{elem.nm}</option>
                  )
                })) : ''}
          </Form.Select>
        </Col>
      </Form.Group>
  );
}

export default ComboFaultGrade;





